angular.module('psModule')
    .factory('employmentService', function ($http) {
        return {
            getCurrentSalary: function() {
                return $http.get('/ps/api/employment/salary');
            }
        };
    });
